import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/builders/$builder_id/communities/$community_id/$")({
  beforeLoad: ({ params }) => {
    const splat = params["_splat"] ?? "";
    throw redirect({
      to: `/builders/${params.builder_id}/locations/${params.community_id}/${splat}` as string,
      statusCode: 301,
    });
  },
});
